import jwtDecode from 'jwt-decode';
import moment, { Moment } from 'moment'
import { router } from './router'
import store from './store'
import { ISession } from './types';

class TokenObserver {

  private debounceTimeout: boolean = false;

  private token: string | null = null;

  private tokenExpiration!: Moment;

  private threshold!: Moment;

  private idleTimeout!: number;

  private interval!: number;

  private monitorDuration: number = 0;

  private clickRef!: any;

  private keyRef!: any;

  private touchRef!: any;

  private mouseRef!: any;

  private focusRef!: any;

  private static instance: TokenObserver;

  private constructor(initialToken?: string) {

    if (initialToken) {

      this.startObserver(initialToken);
    }
  }

  private startObserver(token: string) {
    
    this.token = token;

    document.addEventListener('click', this.clickRef = this.onInteraction.bind(this));
    document.addEventListener('keydown', this.keyRef = this.onInteraction.bind(this));
    window.addEventListener('touchend', this.touchRef = this.onInteraction.bind(this));
    document.addEventListener('mousemove', this.mouseRef = this.onInteraction.bind(this));
    window.addEventListener('focus', this.focusRef = this.onInteraction.bind(this));

    const user = jwtDecode( token ) as ISession;
  
    if ( user.exp !== null ) {

      this.tokenExpiration = moment(user.exp * 1000);
      this.threshold = moment(this.tokenExpiration).subtract({ minutes: 10 });
      this.idleTimeout = this.tokenExpiration.diff(moment()) / 1000;
      this.interval = setInterval(this.onInterval.bind(this), 5000);
    }
  }

  private authenticated(): boolean {
    
    return moment() >= this.tokenExpiration;
  }

  private authThreshold(): boolean {

    return moment().isBetween(this.threshold, this.tokenExpiration);
  }

  private async reAuthenticate() {
    
    return store.dispatch('reauthenticate');
  }

  private onInteraction() {

    if (!this.debounceTimeout) {

      this.debounceTimeout = !this.debounceTimeout;
      setTimeout(() => this.debounceTimeout = !this.debounceTimeout, 1000);

      if (this.authThreshold()) {
        
        return this.reAuthenticate();
      }

      if (this.authenticated()) {

        store.commit('destroySession');
        return router.replace({name: 'login'});
      }

      return;
    }
  }

  private onInterval() {

    this.monitorDuration += 5;

    if (this.monitorDuration >= this.idleTimeout) {

      store.commit('destroySession');
      return router.replace({name: 'login'});
    }

    return;
  }

  public static getInstance(initialToken?: string) {

    if (!TokenObserver.instance) {

      return TokenObserver.instance = new TokenObserver(initialToken)
    }

    if(initialToken) {

      TokenObserver.instance.startObserver(initialToken);
    }

    return TokenObserver.instance;
  }

  public stopObserver(): void {
    this.monitorDuration = 0;
    clearInterval(this.interval);
    document.removeEventListener('click', this.clickRef);
    document.removeEventListener('keydown', this.keyRef);
    window.removeEventListener('touchend', this.touchRef);
    document.removeEventListener('mousemove', this.mouseRef);
    window.removeEventListener('focus', this.focusRef);
  }
}

export function getInstance(initialOrUpdateToken: string) { return TokenObserver.getInstance(initialOrUpdateToken); }
export function stopObserver(): void { TokenObserver.getInstance().stopObserver(); }